module.exports = __webpack_public_path__ + "img/pyramid-two.0968b4ac.svg";